/**
 * required の可否を返す
 */
export const required = (val: any): boolean => {
  const type = typeof val
  if (type === 'string') {
    return !!val.trim()
  } else if (type === 'number') {
    return val > -1
  } else {
    return val
  }
}

/**
 * validation を用いて可否を返す
 *
 * @example
 * const validation = {
 *   email: {
 *     required: required(email)
 *   }
 * }
 * valid(validation)
 */
export const valid = (validation: any): boolean => {
  const fields = Object.keys(validation)

  let valid = true
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i]
    const validationAllOK = (key: string): boolean => validation[field][key]
    valid = Object.keys(validation[field]).every(validationAllOK)
    if (!valid) break
  }
  return valid
}
